
class CustomSearch {
  constructor({
    ResultName = null,
    ResultID = null,
    CityID = null,
    LocalityID = null,
    SocietyID = null,
    AreaID = null,
    flag = null,
    
  } = {}) {
    this.ResultName = ResultName;
    this.ResultID = ResultID;
    this.CityID = CityID;
    this.LocalityID = LocalityID;
    this.SocietyID = SocietyID;
    this.AreaID = AreaID;
    this.flag = flag;
  
  }
}

export default CustomSearch;